import styles from './HilfeLink.module.css';

interface HilfeLinkProps {
  /** Artikel-ID, optional mit Anker: "studierende-hinzufuegen#csv-import" */
  artikel: string;
  /** Barrierefreier Beschreibungstext, z. B. "Hilfe zum CSV-Import" */
  titel: string;
}

/**
 * Kontextuelles "?"-Icon, das den passenden Hilfe-Artikel in einem neuen Tab
 * öffnet (neuer Tab, damit Eingaben/Wizard-Zustand der aktuellen Seite
 * unangetastet bleiben und kein Unsaved-Changes-Modal ausgelöst wird).
 */
export default function HilfeLink({ artikel, titel }: HilfeLinkProps) {
  return (
    <a
      href={`/hilfe/${artikel}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.hilfeLink}
      title={titel}
      aria-label={titel}
      onClick={(e) => e.stopPropagation()}
    >
      ?
    </a>
  );
}
